class Bounds {
  constructor({ top, bottom, left, right } = {}) {
    if (top > bottom || left > right) {
      throw new Error(`Invalid bounds: ${top}, ${bottom}, ${left}, ${right}`);
    }
    this.top = top;
    this.bottom = bottom;
    this.left = left;
    this.right = right;
  }

  static fromElement(el) {
    return new Bounds({
      top: el.getBoundingClientRect().top + window.pageYOffset,
      bottom: el.getBoundingClientRect().bottom + window.pageYOffset,
      left: el.getBoundingClientRect().left + window.pageXOffset,
      right: el.getBoundingClientRect().right + window.pageXOffset,
    });
  }

  static fromPoints(start, end) {
    const [top, bottom] = end.y > start.y ? [start.y, end.y] : [end.y, start.y];
    const [left, right] = end.x > start.x ? [start.x, end.x] : [end.x, start.x];
    return new Bounds({ top, bottom, left, right });
  }

  intersects(bounds) {
    return (
      this.right > bounds.left &&
      this.left < bounds.right &&
      this.bottom > bounds.top &&
      this.top < bounds.bottom
    );
  }

  intersectsRow(r) {
    return this.top < r.bottom && this.bottom > r.top;
  }

  intersectsColumn(c) {
    return this.left < c.right && this.right > c.left;
  }

  contains(point) {
    const { x, y } = point;
    if (x === undefined || y === undefined) throw new Error('Invalid point');
    return this.left < x && this.right > x && this.top < y && this.bottom > y;
  }
}

module.exports = Bounds;
